import { FunctionComponent } from 'react';
import classnames from 'classnames';

import StyledComponent from './styles';
import { Props } from './types';

const LayoutImage: FunctionComponent<Props> = ({ containerProps, imgProps, rounded }) => ((
    <StyledComponent
        {...containerProps}
        className={classnames(
            'layout-image',
            { rounded }
        )}

    >
        <img
            className="image"
            {...imgProps}
            loading="lazy"
        />
    </StyledComponent>
));

export default LayoutImage;